// extracted by mini-css-extract-plugin
module.exports = {"HorizontalLine":"HorizontalLine_HorizontalLine__1ohB-"};